import type { ReactNode } from "react"
import { cn } from "~/lib/utils"

export function DetailsSection({
	title,
	action,
	children,
	variant = "default",
	className
}: {
	title?: string
	action?: ReactNode
	children: ReactNode
	variant?: "default" | "grouped"
	className?: string
}) {
	return (
		<section
			className={cn(
				"min-w-0 p-4",
				variant === "default" &&
					"rounded-xl surface-raised bg-background-secondary",
				variant === "grouped" && "not-first:border-t not-first:border-stroke",
				className
			)}
		>
			{action ? (
				<div className="mb-3 flex items-center justify-between gap-3">
					<p className="text-xs font-medium uppercase tracking-[0.12em] text-text-sub">
						{title}
					</p>
					{action}
				</div>
			) : title ? (
				<p className="mb-3 text-xs font-medium uppercase tracking-[0.12em] text-text-sub">
					{title}
				</p>
			) : null}
			{children}
		</section>
	)
}

export function DetailsRow({
	label,
	children,
	orientation = "default",
	className
}: {
	label: ReactNode
	orientation?: "default" | "stacked" | "spread"
	children: ReactNode
	className?: string
}) {
	return (
		<div
			className={cn(
				"min-w-0",
				orientation === "stacked"
					? "flex flex-col gap-1"
					: orientation === "spread"
						? "flex items-center justify-between gap-4"
						: "grid grid-cols-[5rem_minmax(0,1fr)] items-center gap-3",
				className
			)}
		>
			<span className="text-xs font-medium text-text-sub">{label}</span>
			{children}
		</div>
	)
}
